import { render, staticRenderFns } from "./companyDocsList.vue?vue&type=template&id=25870f7a&"
import script from "./companyDocsList.vue?vue&type=script&lang=js&"
export * from "./companyDocsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports